'use strict';
import {MerchandiseBlock} from './merchandise-block';
import {Pager} from './pager';
import {Sidebar} from './sidebar';
import {Notes} from './notes';

export function MainContent(type, id, page, merchandises, categories) {
  Object.defineProperties(this, {
    "categories": {
      get: function() {return this._categories;},
      set: function(values) {
        if(!values) {
          throw new TypeError('関連商品カテゴリーが指定されていません。');
        }
        this._categories = categories;
      },
      enumerable: true
    },
    "id": {
      get: function() {return this._id;},
      set: function(value) {
        if(!value) {
          throw new TypeError('該当する商品IDが指定されていません。');
        }
        this._id = value;
      },
      enumerable: true
    },
    "merchandises": {
      get: function() {return this._merchandises;},
      set: function(merchandises) {
        if(!merchandises) {
          throw new TypeError('該当する関連商品情報が指定されていません。');
        }
        this._merchandises = merchandises;
      },
      enumerable: true
    },
    "page": {
      get: function() {return this._page;},
      set: function(values) {
        if(!values) {
          throw new TypeError('ページ情報が指定されていません。');
        }
        if(!('current' in values)) {
          throw new ReferenceError('現在ページの情報が含まれていません。');
        }
        if(!('last' in values)) {
          throw new ReferenceError('最終ページの情報が含まれていません。');
        }
        this._page = values;
      },
      enumerable: true
    },
    "type": {
      get: function() {return this._type;},
      set: function(value) {
        if(!value) {
          throw new TypeError('関連商品の絞り込み種類が指定されていません。');
        }
        this._type = value;
      },
      enumerable: true
    }
  });
  this.type = type;
  if(id) {
    this.id = id;
  }
  this.page = page;
  this.merchandises = merchandises;
  this.categories = categories;
};
MainContent.prototype.create = function() {
  var df = document.createDocumentFragment();
  var content = document.createElement('div');
  content.id = 'merchandise';
  content.className = 'content_width clearfix';
  df.appendChild(content);

  var leftSection = content.cloneNode(false);
  leftSection.removeAttribute('id');
  leftSection.className = 'block04';
  df.firstChild.appendChild(leftSection);

  var rightSection = leftSection.cloneNode(false);
  rightSection.className = 'block03';
  df.firstChild.appendChild(rightSection);

  var headline = document.createElement('h1');
  var headlineImage = document.createElement('img');
  headlineImage.src = '../img/pic_relation_topic.png';
  headlineImage.alt = '関連商品';
  headlineImage.width = 180;
  headlineImage.height = 69;
  headline.appendChild(headlineImage);
  df.querySelector('.block04').appendChild(headline);

  var container = leftSection.cloneNode(false);
  container.className = 'container container--merchandise';
  df.querySelector('.block04').appendChild(container);

  if(this.id) {
    if(!(/i(ndex|tem)|chara/.test(this.type))) {
      var subHeadline = document.createElement('h2');
      subHeadline.className = 'headline--category';

      var subHeadlineImage = headlineImage.cloneNode(false);
      var chooseResult = this.chooseCategoryTitle();
      subHeadlineImage.src = '../img/' + chooseResult.filename;
      subHeadlineImage.alt = chooseResult.alt;
      subHeadlineImage.width = 704;
      subHeadlineImage.height = 62;
      subHeadline.appendChild(subHeadlineImage);
      df.querySelector('.block04 > .container').appendChild(subHeadline);
    }
  }

  this.merchandises.forEach(function(merchandise) {
    var merchandiseBlock = new MerchandiseBlock(merchandise);
    df.querySelector('.block04 > .container').appendChild(merchandiseBlock.create());
  });

  if(this.page.last !== 1) {
    var pager = new Pager(this.type, this.id, this.page);
    df.querySelector('.block04 > .container').appendChild(pager.create());
  }

  var banner = container.cloneNode(false);
  banner.className = 'container--banner';
  var bannerImage = headlineImage.cloneNode(false);
  bannerImage.src = '../img/pic_coming_soon.png';
  bannerImage.alt = '順次情報追加予定！';
  bannerImage.width = 382;
  bannerImage.height = 100;
  banner.appendChild(bannerImage);
  df.querySelector('.block04 > .container').appendChild(banner);

  var sidebar = new Sidebar(KAGURA.merchandise.id, this.categories);
  df.querySelector('.block03').appendChild(sidebar.create());

  var notes = new Notes();
  df.querySelector('.block03').appendChild(notes.create());
  return df;
};
MainContent.prototype.chooseCategoryTitle = function() {
  var m = Object.create(null);
  switch(this.id) {
    case 'pillowcover':
      m.filename = 'pic_relation_cate01.png';
      m.alt = '抱き枕カバー';
      break;
    case 'mousepad':
      m.filename = 'pic_relation_cate02.png';
      m.alt = 'おっぱいマウスパッド';
      break;
    case 'apparel':
      m.filename = 'pic_relation_cate03.png';
      m.alt = 'アパレル';
      break;
    case 'charagoods':
      m.filename = 'pic_relation_cate04.png';
      m.alt = 'キャラクターグッズ';
      break;
    case 'tapestry':
      m.filename = 'pic_relation_cate05.png';
      m.alt = 'タペストリー';
      break;
    case 'figure':
      m.filename = 'pic_relation_cate06.png';
      m.alt = 'フィギュア';
      break;
    case 'books':
      m.filename = 'pic_relation_cate07.png';
      m.alt = '書籍';
      break;
    case 'comics':
      m.filename = 'pic_relation_cate08.png';
      m.alt = 'コミックス';
      break;
    case 'video':
      m.filename = 'pic_relation_cate09.png';
      m.alt = '映像・CD';
      break;
    case 'application':
      m.filename = 'pic_relation_cate010.png';
      m.alt = 'アプリ';
      break;
    case 'line':
      m.filename = 'pic_relation_cate011.png';
      m.alt = 'LINEアイテム';
      break;
  }
  return m;
};